module.exports = __webpack_public_path__ + "static/14-thumb-84d011799ad9a2c0168963cb2e8612c4.jpg";